import CustomerPortalWrapper from '../../pages/customer-portal/_index.jsx';
import CustomerPortalAccount from '../../pages/customer-portal/account.jsx';
import {
  CampaignsRaffle,
  CustomerPortalCampaignsShow,
} from '../../pages/customer-portal/campaigns/_index.js';
import CustomerPortalCouponsList from '../../pages/customer-portal/coupons.jsx';
import CustomerPortalIndex from '../../pages/customer-portal/index.jsx';

export const customerPortalRoutes = {
  path: '/portal',
  element: <CustomerPortalWrapper />,
  children: [
    { index: true, element: <CustomerPortalIndex /> },
    {
      path: ':campaignName',
      children: [
        { index: true, element: <CustomerPortalCampaignsShow /> },
        { path: 'raffle', element: <CampaignsRaffle /> },
      ],
    },
    { path: 'account', element: <CustomerPortalAccount /> },
    {
      path: 'coupons',
      children: [{ index: true, element: <CustomerPortalCouponsList /> }],
    },
  ],
};
